import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import {
  ENTERPRISE_SYSTEMS_PAGE,
  buildEnterpriseSystemsStructuredData,
} from '../data/enterpriseSystemsPage';

const EnterpriseSystemsPage = () => (
  <ServiceLandingPage
    seoPath="/enterprise-systems"
    pageData={ENTERPRISE_SYSTEMS_PAGE}
    buildStructuredData={buildEnterpriseSystemsStructuredData}
  />
);

export default EnterpriseSystemsPage;
